<div class="login-bg">
  <div class="row w-100 align-items-center">
    <div class="col-lg-6 d-flex">
      <div class="auth-logo m-auto">
        <img src="assets/images/admin-logo-v2.png" class="img-fluid" alt="" />
      </div>
    </div>
    <div class="col-lg-6">
      <div class="splash-container login-wrap d-flex align-items-center">
          <div class="card px-2 py-5 mb-0">
              <div class="card-body text-center">
                      <h1>OTP Verification</h1>
                      <span class="splash-description">Please enter the OTP</span>
                        
                      <div class="alert alert-danger" *ngIf="incorrect">
                        <button mat-button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <i class="material-icons">close</i>
                        </button>
                        <span>
                           OTP is Incorrect</span>
                      </div>
                      <div class="alert alert-primary" *ngIf="opt_sent">
                        <button mat-button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <i class="material-icons">close</i>
                        </button>
                        <span>
                           OTP Sent</span>
                      </div>
                      <div  class="form-group d-flex justify-content-center my-4">
                        <ng-otp-input  (onInputChange)="onOtpChange($event)"  [config]="{length:4}"></ng-otp-input>
                      </div>
                   
                    <span style="text-align: center;">Time Left: <span style="font-size: larger; font-weight: bold;">{{timeLeft}}</span></span>
                    <div class="py-sm-1 pt-md-1 pt-lg-2 pt-xl-4">
                        <div class="d-flex justify-content-center" >
                          
                          <label class="d-inline-block" *ngIf="isTimerExpired()">Not Received Yet? <a href="javascript:void(0);" (click)="sendOtp()" class="red-link">Send Again</a></label>
                        </div>
                        <div class="d-flex justify-content-center">
                            <label class="d-inline-block">Create Again? <a routerLink="/register" routerLinkActive="active" class="red-link">SignUp</a></label>
                        </div>
                    </div>
                
        </div>
          </div>
      </div>
    </div>
  </div>
</div>  
  <ng-template #myModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title mb-0" id="exampleModalLabel">OTP Verified</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{messaage}}
        
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="close()">Ok</button>
      </div>
  
  </ng-template>